import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Coevaluation from 'components/UI/Coevaluation/Coevaluation';

let coevaluationInfo = [];
let showCoevaluationsHomework = [];
const AVGCoevaluation = () => {
  const [loading, setLoading] = useState(true);
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    if (
      dataLesson.coevaluationsHomeWork &&
      dataLesson.coevaluationsHomeWork.length > 0 &&
      dataLesson.coevaluationsItems
    ) {
      dataLesson.coevaluationsHomeWork.map(coevalHomeworkItem => {
        const arrValues = coevaluationToArray(
          coevalHomeworkItem.coevaluation
        );
        let arrCoResult = new Array(
          dataLesson.coevaluationsItems.length
        );
        for (let i = 0; i < arrCoResult.length; i++) {
          arrCoResult[i] = {
            item: dataLesson.coevaluationsItems[i].item,
            value: arrValues[i],
            coevaluationOrder: i + 1
          };
        }
        coevaluationInfo = new Array(arrCoResult);
        showCoevaluationsHomework = coevaluationInfo;
        let couevaluationHomeworkInfoN = [];
        let arrCoResultD = new Array(
          dataLesson.coevaluationsItems.length
        );
        for (
          let i = 0;
          i < dataLesson.coevaluationsItems.length;
          i++
        ) {
          let valuesA = 0;
          for (
            let j = 0;
            j < showCoevaluationsHomework.length;
            j++
          ) {
            valuesA = showCoevaluationsHomework[j][i].value;
            arrCoResultD[i] = {
              item: dataLesson.coevaluationsItems[i].item,
              value: valuesA,
              coevaluationOrder: i + 1
            };
          }
        }
        couevaluationHomeworkInfoN = arrCoResultD;
        showCoevaluationsHomework = couevaluationHomeworkInfoN;
      });
      setLoading(false);
    }
  }, [
    dataLesson.coevaluationsHomeWork,
    dataLesson.coevaluationsItems
  ]);

  const coevaluationToArray = c => {
    const factors = [
      1, 5, 25, 125, 625, 3125, 15625, 78125, 390625, 1953125
    ];
    const limits = [
      5, 30, 155, 780, 3905, 19530, 97655, 488280, 2441405, 12207030
    ];
    if (c > 0 && c <= limits[limits.length - 1]) {
      let z = 1;
      for (let k = 0; k < limits.length - 1; k++) {
        if (c > limits[k]) {
          z++;
        } else {
          break;
        }
      }
      let a = new Array(z);
      for (let i = z - 1; i >= 0; i--) {
        let j = 0;
        for (j = 1; j <= 5; j++) {
          c = c - factors[i];
          a[i] = j;
          if ((i > 0 && c <= limits[i - 1]) || c === 0) {
            break;
          }
        }
      }
      return a;
    }
    return [];
  };

  return (
    !loading && (
      <Coevaluation
        notCoeval
        coevaluationItems={showCoevaluationsHomework}
      />
    )
  );
};

export default AVGCoevaluation;
